
export default {
	ACCESS_TOKEN: 'accessToken',
	REFRESH_TOKEN: 'refreshToken',
	USER_DETAILS: 'userDetails',
	SUBJECT: 'subject',
	MANAGE_BOOKING_SEARCH_INFO: 'bookingSearchFormData',
	MANAGE_SLR_SEARCH_INFO: 'slrSearchFormData',
	SLR_LIST_DETAILS: 'slrListInputData',
	SLR_FALLBACK_STATION: 'slrFallbackStation',
	SEARCH_FORM_DATA_BOOKING: 'searchObject',
	SELECTED_FLIGHT_BOOKING: 'flightSelected',
	GEO_LOCATION: 'edge.geoLocation',
	SSO_REFRESH_URL: 'SSORefreshUrl',
	SSO_TYPE: 'SSOType',
	PERMANENT_BKG_FLG: 'PermanentBkgFlg',
	HAWB_UPLD_FLG: 'HAWBUpldFlg',
	PLACI_USER_DETAILS: 'placiUserDetails',
	AGENT_COUNTRY: 'agentCountry',
	GSA_AGENT_DETAILS : 'GsaAgentDetails',
	I18NEST_LNG: 'i18nextLng',
	AIRPORTS_MASTER: 'airportsMaster',
	SHIPMENT_TRACKING_DETAILS : 'shipmentTrackingInputData',
	MULTIPLE_BOOKING_DATA:'multipleBookingData',
	ROUTE_ENQUIRY_AIRPORT_MAIL_DATA : 'routeEnquiryAirportMailData',
	UPDATE_BOOKING_DATA : 'updateBookingData',
}
